enum PersonalityType {
    I = "Introverted",
    E = "Extroverted",
    N = "Intuitive",
    S = "Sensing",
    F = "Feeling",
    T = "Thinking",
    P = "Prospecting",
    J = "Judging",
}

export {PersonalityType};